<div *ngIf="pageDesignFlag">
  <div id="{{pageDesign.name}}" [ngStyle]="pageDesign.style">
    
    <div class="full-width">

      <!-- CUSTOM CODE SECTION -->
      <div *ngIf="customDesign">
        
        <div [innerHTML]="htmlText | sanitizeHtml"></div>

      </div>

      <!-- NON CUSTOM CODE SECTION -->
      <div *ngIf="!customDesign">

        <div *ngFor="let ele of pageDesign.element_flow" style="width: 100%;">
        
          <img *ngIf="ele.type=='image'" src="{{ele.src}}" alt="" srcset="" [ngStyle]="ele.style">
        
          <p *ngIf="ele.type=='text'" [ngStyle]="ele.style" [innerHTML]="ele.text | sanitizeHtml"></p>
        
          <p *ngIf="ele.type=='sub-text' && ele.text!= 'null'" [ngStyle]="ele.style" [innerHTML]="ele.text | sanitizeHtml"></p>
          
          <p *ngIf="ele.type=='link'" [ngStyle]="ele.style" [innerHTML]="ele.text | sanitizeHtml">&nbsp;<a [href]="ele.link" >{{ele.linkText}}</a></p>
        
          <div  *ngIf="ele.type=='button'">
            
            <button mat-raised-button [ngStyle]="ele.style" *ngIf="customService.server_response_recieved" 
              (click)="customService.triggerFunction(ele)" [innerHTML]="ele.text | sanitizeHtml"></button>
            <div *ngIf="!customService.server_response_recieved" [ngStyle]="customService.getLoadingTextStyle()" id="load-wrapper-div">
              <div class="wrapper">
                <div class="loading-text"> 
                  <p id="loadText" i18n>LOADING
                    <span class="dot-one"> .</span>
                    <span class="dot-two"> .</span>
                    <span class="dot-three"> .</span>
                  </p>
                </div> 
              </div> 
            </div>
          </div>
          
          <div *ngIf="ele.type=='custom'" [innerHTML]="ele.custom_html | sanitizeHtml"></div>
          
        </div>
    
      </div>
    
    </div>

  </div>
</div>